import { SEARCH_POSTAL_CODE } from 'constants/postal-code';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const postalCodeDataReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${SEARCH_POSTAL_CODE}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${SEARCH_POSTAL_CODE}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${SEARCH_POSTAL_CODE}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
